import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RefreshService {
  private refreshSubject = new Subject<string>();
  public refresh$ = this.refreshSubject.asObservable();
  private currentRoute: string = '';

  constructor(private router: Router) {
    // Keep track of the current route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentRoute = event.urlAfterRedirects;
    });
  }

  /**
   * Trigger a refresh for the current route
   */
  public refreshCurrentRoute(): void {
    this.refreshSubject.next(this.currentRoute);
  }

  /**
   * Trigger a refresh for a specific route
   * @param route The route to refresh
   */
  public refreshRoute(route: string): void {
    this.refreshSubject.next(route);
  }
}
